function e(e){return"Enter"===e.key||13===e.keyCode||""===e.key||32===e.keyCode}export{e as b};
//# sourceMappingURL=accessibility-f5eea9eb.js.map
